module.exports = __webpack_public_path__ + "static/img/puttkammer.a4ddf5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/nilfgaardian/puttkammer.png
// module id = mP3Y
// module chunks = 0